import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  FormControl,
  Textarea,
  useToast,
  Input,
  Stack,
} from '@chakra-ui/react'
import { useMutation } from 'react-query'
import { api } from '../../../../services/api'
import { user } from '../../../../helpers/user'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup.object().shape({
  descricao_usuario: yup.string().required('Descrição obrigatória'),
  nome_usuario_desconto: yup.string().required('Nome obrigatório'),
  quantidade_pecas: yup.number().required('Quantidade obrigatória'),
})

export function DescontoProdutoModal({
  coditoProduto,
  quantidade,
  filtrarStatus,
  ad_numinno,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  })

  const codUsu = user?.codigo_usuario

  const toast = useToast({
    position: 'top-right',
  })

  const { mutateAsync } = useMutation(
    async (data) => {
      const response = await api.post('/pedido/inserir-usuario-desconto', {
        codigo_usuario: codUsu,
        codigo_produto: coditoProduto,
        quantidade_pecas: data.quantidade_pecas,
        descricao_usuario: data.descricao_usuario,
        nome_usuario_desconto: data.nome_usuario_desconto,
        ad_numinno,
      })

      return response.data
    },
    {
      onSuccess: () => {
        onClose()
        filtrarStatus()
        reset()
        toast({
          title: 'Desconto aplicado com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true,
        })
      },
      onError: (error) => {
        console.log(error)
        toast({
          title: 'Erro ao aplicar desconto',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      },
    }
  )

  async function handleDesconto(data) {
    try {
      await mutateAsync(data)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <Button onClick={onOpen} colorScheme="blue" size="sm">
        Desconto
      </Button>
      <Modal
        onClose={onClose}
        isOpen={isOpen}
        isCentered
        size="xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit(handleDesconto)}>
          <ModalHeader>Desconto</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <p>Produto: {coditoProduto}</p>

              <Stack direction="column" spacing={4} marginTop="4">
                <Input
                  type="text"
                  {...register('nome_usuario_desconto')}
                  placeholder="Nome do usuário"
                />
                <Input
                  type="number"
                  {...register('quantidade_pecas')}
                  placeholder="Quantidade de peças"
                />

                <Textarea
                  placeholder="Descrição"
                  {...register('descricao_usuario')}
                />
              </Stack>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              isLoading={isSubmitting}
              type="submit"
            >
              Confirmar
            </Button>
            <Button variant="ghost">Cancelar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
